(() => {
  const packageId = 'com.CSoreillysboutique.android';
  let installPrompt = null;
  let prompting = false;

  window.addEventListener('beforeinstallprompt', (event) => {
    if (!event.platforms?.includes('play')) return;

    // Keep Chrome's own install promotion enabled; never substitute a web-app install.
    installPrompt = event;
    const clearPrompt = () => {
      if (installPrompt === event) installPrompt = null;
    };
    event.userChoice.then(clearPrompt, clearPrompt);
  });

  window.addEventListener('appinstalled', () => {
    installPrompt = null;
  });

  document.addEventListener('click', async (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest?.('a[data-android-app-install]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    let url;
    try {
      url = new URL(link.href);
    } catch {
      return;
    }
    // Respect a merchant-supplied destination if the badge is changed to another app.
    if (url.origin !== 'https://play.google.com' || url.pathname !== '/store/apps/details' || url.searchParams.get('id') !== packageId) return;
    if (!installPrompt && !prompting) return;

    event.preventDefault();
    if (prompting) return;

    const currentPrompt = installPrompt;
    installPrompt = null;
    prompting = true;
    try {
      // Must run directly in the click gesture. Each browser event can only be used once.
      await currentPrompt.prompt();
      await currentPrompt.userChoice;
    } catch {
      window.location.assign(link.href);
    } finally {
      prompting = false;
    }
  });
})();
